import React from 'react';
import { Grid, FormControl, InputLabel, FilledInput, InputAdornment, Box } from '@mui/material';
import { currencyFormatter } from './CurrencyFormat';

const OneFieldTotal = ({ id, label, value }) => {
    return (
        <Grid container spacing={2} sx={{ mt: 2, justifyContent: { xs: 'center', sm: 'flex-end' } }}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box>
                    <FormControl fullWidth variant="filled">
                        <InputLabel htmlFor={id} sx={{ fontSize: '18px' }}>
                            <strong>{label}</strong>
                        </InputLabel>
                        <FilledInput
                            id={id}
                            startAdornment={<InputAdornment position="start">€</InputAdornment>}
                            value={currencyFormatter(value)}
                            readOnly
                        />
                    </FormControl>
                </Box>
            </Grid>
        </Grid>
    );
};

export default OneFieldTotal;
